import React from 'react';
import { getFormattedDate } from '@lib/utils/dateTimeHelpers';
import Typography from '@lib/components/Typography/Typography';
import styles from './MonitoringChartTooltip.module.scss';

interface TooltipParams {
  series: number[][];
  seriesIndex: number;
  dataPointIndex: number;
  w: {
    globals: {
      seriesX: number[][];
      seriesNames: string[];
      colors: string[];
    };
  };
}

export const createCustomTooltip = () => {
  return function renderTooltip({
    series: seriesArray,
    seriesIndex,
    dataPointIndex,
    w,
  }: TooltipParams) {
    const date = new Date(w.globals.seriesX[seriesIndex][dataPointIndex]);

    let content = '';
    w.globals.seriesNames.forEach((name: string, index: number) => {
      const value = seriesArray[index]?.[dataPointIndex];
      if (value !== undefined && value !== null) {
        const color = w.globals.colors[index];
        content += `
          <div class="${styles.tooltipRow}">
            <div class="${styles.colorIndicator}" style="background-color: ${color};"></div>
            <span class="${styles.value}">${value}</span>
            <span class="${styles.entityName}">${name}</span>
          </div>
        `;
      }
    });

    return `
      <div class="${styles.tooltip}">
        <div class="${styles.title}">${getFormattedDate(date)}</div>
        ${content}
      </div>
    `;
  };
};

// Alternative React component version (if needed for future use)
interface MonitoringChartTooltipProps {
  date: Date;
  series: Array<{
    name: string;
    value: number;
    color: string;
  }>;
}

export default function MonitoringChartTooltip({
  date,
  series,
}: MonitoringChartTooltipProps) {
  return (
    <div className={styles.tooltip}>
      <Typography variant="body" className={styles.title}>
        {getFormattedDate(date)}
      </Typography>
      <div className={styles.list}>
        {series.map(({ value, color }) => (
          <div key={value} className={styles.tooltipRow}>
            <div
              className={styles.colorIndicator}
              style={{ backgroundColor: color }}
            />
            <Typography variant="caption">{value}</Typography>
          </div>
        ))}
      </div>
    </div>
  );
}
